import styled from 'styled-components';
import {
  color,
  container,
  fontWeight,
  radius,
  screen,
  shadow,
  spacing
} from 'theme';
import { StyledJobOfferSubsection } from '../JobOfferSubsection.styled';

export const StyledSkillsSection = styled.div`
  max-width: ${container('lg')};
  margin: auto;

  @media (min-width: ${screen('lg')}) {
    ${StyledJobOfferSubsection} {
      margin-top: ${spacing('xl4')};
    }
  }
`;

export const StyledSkillsLists = styled.div`
  margin-bottom: ${spacing('xl4')};
  margin-top: ${spacing('xl')};
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: ${spacing('xl')};

  > * {
    width: 21rem;
  }

  @media (min-width: ${screen('lg')}) {
    flex-wrap: nowrap;
    margin-left: -${spacing('xl')};
    margin-right: -${spacing('xl')};

    > * {
      width: 33.3%;
      max-width: unset;
    }
  }
`;

export const StyledLanguages = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${spacing('md')};
  flex-direction: row;
  justify-content: center;
`;

export const StyledLanguage = styled.div`
  border: 1px solid ${color('midnight_200')};
  border-radius: ${radius('lg')};
  padding: ${spacing('lg')};
  box-shadow: ${shadow('md')};
  display: flex;
  align-items: center;
  gap: ${spacing('xl')};
  font-weight: ${fontWeight('black')};
  line-height: 1.25;
  width: 100%;

  @media (min-width: ${screen('lg')}) {
    width: ${container('xs2')};
  }
`;

export const StyledLanguageName = styled.div`
  font-weight: ${fontWeight('medium')};
  flex: 1 1 auto;
`;
